import { Route, Routes } from 'react-router-dom';  
import { lazy, Suspense } from 'react';
import LazyLoader from 'components/particles/lazyLoader';
const PrivateRoutes = lazy(() => import('./private/private.routes'));
const PublicRoutes = lazy(() => import('./public/public.routes'));
const ProtectedRoutes = lazy(() => import('containers/guards/protected-route'));
const ExecutiveOverview = lazy(() => import('containers/private/aper/reports/executive-overview'));
const NonProtectedRoutes = lazy(() => import('containers/guards/non-protected-routes'));

const AppRoutes = () => {
    return (
        <Suspense fallback={<LazyLoader />}>
        <Routes>
            <Route path='/private/aper/executive-overview' element={<ProtectedRoutes><ExecutiveOverview /></ProtectedRoutes>} />
            <Route path='/private/*' element={<ProtectedRoutes><PrivateRoutes /></ProtectedRoutes>} />
            <Route path='/*' element={<NonProtectedRoutes><PublicRoutes /></NonProtectedRoutes>} />
        </Routes>
        </Suspense>
    )
}

export default AppRoutes;